import { PaymentContainer } from 'src/components/PaymentContainer/PaymentContainer';
import { PaymentGenericError } from 'src/components/PaymentGenericError/PaymentGenericError';
import type { ListingProduct } from 'src/generated/graphql';
import {
  isEmailAndSearchBoostAdPackCombination,
  isEmailAndSearchBoostStandardCombination,
  isStandardAndSearchBoostCombination,
} from 'src/utils/listingProducts';

import { EmailAndSearchBoostPaymentSuccess } from './components/PaymentSuccessScreens/EmailAndSearchBoostPaymentSuccess';
import { GenericRepostPaymentSuccess } from './components/PaymentSuccessScreens/GenericRepostPaymentSuccess';
import { StandardAndSearchBoostPaymentSuccess } from './components/PaymentSuccessScreens/StandardAndSearchBoostPaymentSuccess';

interface PaymentSuccessWithSecondProductProps {
  clientId: string;
  firstUrlProduct: ListingProduct;
  secondUrlProduct: ListingProduct;
  listingId: string | null;
}

export const PaymentSuccessWithSecondProduct = (
  props: PaymentSuccessWithSecondProductProps,
) => {
  if (
    isEmailAndSearchBoostAdPackCombination(
      props.firstUrlProduct,
      props.secondUrlProduct,
    ) ||
    isEmailAndSearchBoostStandardCombination(
      props.firstUrlProduct,
      props.secondUrlProduct,
    )
  ) {
    return (
      <PaymentContainer width="medium">
        <EmailAndSearchBoostPaymentSuccess />
      </PaymentContainer>
    );
  }

  if (
    isStandardAndSearchBoostCombination(
      props.firstUrlProduct,
      props.secondUrlProduct,
    )
  ) {
    if (props.listingId) {
      return (
        <PaymentContainer width="small">
          <GenericRepostPaymentSuccess
            clientId={props.clientId}
            listingId={props.listingId}
          />
        </PaymentContainer>
      );
    }

    return (
      <PaymentContainer width="medium">
        <StandardAndSearchBoostPaymentSuccess />
      </PaymentContainer>
    );
  }

  // TODO unit test
  return <PaymentGenericError testId="multiple-products-no-match-error" />;
};
